import request from '@u/request'

// 获取测评列表
export function evaluationList(data){
	return request({
		url: '/cms_evaluation/evaluationList',
        method: 'POST',
        data: data || {}
	})
}

// 添加+修改测评
export function evaluationAdd(data){
	return request({
		url: '/cms_evaluation/evaluationAdd',
        method: 'POST',
        data: data || {}
	})
}

// 上传图片
export function upload_image(data){
	return request({
		headers:{
			'Content-Type':'application/x-www-form-urlencoded'
		},
		url: '/cms/upload_image',
		method: 'POST',
		data: data || {}
	})
}
// 删除测评
export function evaluationDel(data){
	return request({
		url: '/cms_evaluation/evaluationDel',
        method: 'POST',
        data: data || {}
	})
}
// 根据id查询测评
export function evaluationEdit(data){
	return request({
		url: '/cms_evaluation/evaluationEdit',
        method: 'POST',
        data: data || {}
	})
}

// ----------------维度设置

// 获取维度列表
export function dimensionsList(data){
	return request({
		url: '/cms_evaluation/dimensionsList',
        method: 'POST',
        data: data || {}
	})
}
// 测评维度添加+修改
export function dimensionsAdd(data){
	return request({
		url: '/cms_evaluation/dimensionsAdd',
        method: 'POST',
        data: data || {}
	})
}

// 	测评维度删除
export function dimensionsDel(data){
	return request({
		url: '/cms_evaluation/dimensionsDel',
        method: 'POST',
        data: data || {}
	})
}

// ----------------试题设置

// 获取试题列表
export function questionList(data){
	return request({
		url: '/cms_evaluation/questionList',
        method: 'POST',
        data: data || {}
	})
}
// 试题添加+修改
export function questionAdd(data){
	return request({
		url: '/cms_evaluation/questionAdd',
        method: 'POST',
        data: data || {}
	})
}

// 	试题删除
export function questionDel(data){
	return request({
		url: '/cms_evaluation/questionDel',
        method: 'POST',
        data: data || {}
	})
}


// 配置常用选项
export function questionConfig(data){
	return request({
		url: '/cms_evaluation/questionConfig',
        method: 'POST',
        data: data || {}
	})
}
// 删除常用选项
export function questionConfigDel(data){
	return request({
		url: '/cms_evaluation/questionConfigDel',
        method: 'POST',
        data: data || {}
	})
}

// ----------------公式设置


// 获取公式规则列表
export function formulaList(data){
	return request({
		url: '/cms_evaluation/formulaList',
        method: 'POST',
        data: data || {}
	})
}

// 公式规则添加+修改
export function formulaAdd(data){
	return request({
		url: '/cms_evaluation/formulaAdd',
        method: 'POST',
        data: data || {}
	})
}

// 	公式规则删除
export function formulaDel(data){
	return request({
		url: '/cms_evaluation/formulaDel',
        method: 'POST',
        data: data || {}
	})
}

// ----------------显示设置
// 显示设置获取和提交接口
export function theme(data){
	return request({
		url: '/cms_evaluation/theme',
        method: 'POST',
        data: data || {}
	})
}


// ----------------动态文字or图片
// 动态图片或文字列表
export function dynamicList(data){
	return request({
		url: '/cms_evaluation/dynamicList',
        method: 'POST',
        data: data || {}
	})
}


// 添加动态图片或文字
export function dynamicImageText(data){
	return request({
		url: '/cms_evaluation/dynamicImageText',
        method: 'POST',
        data: data || {}
	})
}

// 获取单个动态图片或文字
export function getDynamic(data){
	return request({
		url: '/cms_evaluation/getDynamic',
        method: 'POST',
        data: data || {}
	})
}

// 删除动态图片或文字
export function delDynamic(data){
	return request({
		url: '/cms_evaluation/delDynamic',
        method: 'POST',
        data: data || {}
	})
}

// ----------------动态图表
// 获取动态图表列表
export function chartList(data){
	return request({
		url: '/cms_evaluation/chartList',
        method: 'POST',
        data: data || {}
	})
}

// 动态图表添加+修改
export function chartAdd(data){
	return request({
		url: '/cms_evaluation/chartAdd',
        method: 'POST',
        data: data || {}
	})
}

// 	动态图表删除
export function chartDel(data){
	return request({
		url: '/cms_evaluation/chartDel',
        method: 'POST',
        data: data || {}
	})
}


// ----------------动态海报

// 	动态海报列表
export function postersList(data){
	return request({
		url: '/cms_evaluation/postersList',
        method: 'POST',
        data: data || {}
	})
}

// 	动态海报添加or修改
export function posters(data){
	return request({
		url: '/cms_evaluation/posters',
        method: 'POST',
        data: data || {}
	})
}

// 	动态海报删除
export function delPosters(data){
	return request({
		url: '/cms_evaluation/delPosters',
        method: 'POST',
        data: data || {}
	})
}

//
// 	动态海报查询
export function getPosters(data){
	return request({
		url: '/cms_evaluation/getPosters',
        method: 'POST',
        data: data || {}
	})
}
// 	动态海报预览
export function previewPosters(data){
	return request({
		url: '/cms_evaluation/previewPosters',
        method: 'POST',
        data: data || {}
	})
}


// ----------------报告页面

// 	报告列表
export function reportList(data){
	return request({
		url: '/cms_evaluation/reportList',
        method: 'POST',
        data: data || {}
	})
}

// 	报告查询单条
export function getReport(data){
	return request({
		url: '/cms_evaluation/getReport',
        method: 'POST',
        data: data || {}
	})
}
// 	报告配置
export function reportConfig(data){
	return request({
		url: '/cms_evaluation/reportConfig',
        method: 'POST',
        data: data || {}
	})
}
// 	报告获取类型
export function getTypeList(data){
	return request({
		url: '/cms_evaluation/getTypeList',
        method: 'POST',
        data: data || {}
	})
}
// 	报告删除
export function delRport(data){
	return request({
		url: '/cms_evaluation/delRport',
        method: 'POST',
        data: data || {}
	})
}
// 	获取所有报告
export function reportAll(data){
	return request({
		url: '/cms_evaluation/reportAll',
        method: 'POST',
        data: data || {}
	})
}
// 报告排序
export function reportSort(data){
	return request({
		url: '/cms_evaluation/reportSort',
        method: 'POST',
        data: data || {}
	})
}
// 报告预览
export function previewReport(data){
	return request({
		url: '/cms_evaluation/previewReport',
        method: 'POST',
        data: data || {}
	})
}

// ----------------测评预览
export function previewEvaluation(data){
	return request({
		url: '/cms_evaluation/previewEvaluation',
        method: 'POST',
        data: data || {}
	})
}

// ----------------测评试用列表
export function groupList(data){
	return request({
		url: '/cms_ceping/groupList',
        method: 'POST',
        data: data || {}
	})
}
// ----------------测评列表
export function cepingList(data){
	return request({
		url: '/cms_ceping/cepingList',
        method: 'POST',
        data: data || {}
	})
}
// ----------------测评生成试用链接
export function addGroup(data){
	return request({
		url: '/cms_ceping/addGroup',
        method: 'POST',
        data: data || {}
	})
}
// ----------------测评失效试用链接
export function disableGroup(data){
	return request({
		url: '/cms_ceping/disableGroup',
        method: 'POST',
        data: data || {}
	})
}
// ----------------测评试用使用记录
export function useList(data){
	return request({
		url: '/cms_ceping/useList',
        method: 'POST',
        data: data || {}
	})
}
// ----------------测评试用导出
export function exportUseList(data){
	return request({
		url: '/cms_ceping/exportUseList',
        method: 'POST',
        data: data || {}
	})
}

// ----------------测评banner列表
export function bannerList(data){
	return request({
		url: '/cms_ceping/bannerList',
        method: 'POST',
        data: data || {}
	})
}
// ----------------测评获取banner
export function getBanner(data){
	return request({
		url: '/cms_ceping/getBanner',
        method: 'POST',
        data: data || {}
	})
}
// ----------------测评banner 生效/失效
export function changeBannerStatus(data){
	return request({
		url: '/cms_ceping/changeBannerStatus',
        method: 'POST',
        data: data || {}
	})
}
// ----------------测评添加banner
export function addBanner(data){
	return request({
		url: '/cms_ceping/addBanner',
        method: 'POST',
        data: data || {}
	})
}
// ----------------测评编辑banner
export function updateBanner(data){
	return request({
		url: '/cms_ceping/updateBanner',
        method: 'POST',
        data: data || {}
	})
}
// ----------------测评删除banner
export function deleteBanner(data){
	return request({
		url: '/cms_ceping/deleteBanner',
        method: 'POST',
        data: data || {}
	})
}

// ----------------测评用户信息管理列表
export function userinfoList(data){
	return request({
		url: '/cms_ceping/userinfoList',
        method: 'POST',
        data: data || {}
	})
}
// ----------------测评用户信息导出
export function userinfoExport(data){
	return request({
		url: '/cms_ceping/userinfoExport',
        method: 'POST',
        data: data || {}
	})
}
// ----------------测评用户信息选项管理列表
export function userinfoOptionList(data){
	return request({
		url: '/cms_ceping/userinfoOptionList',
        method: 'POST',
        data: data || {}
	})
}

// ----------------测评用户信息选项 下拉选项
export function userinfoOptionSelect(data){
	return request({
		url: '/cms_ceping/userinfoOptionSelect',
        method: 'POST',
        data: data || {}
	})
}
// ----------------测评添加用户信息选项
export function addUserinfoOption(data){
	return request({
		url: '/cms_ceping/addUserinfoOption',
        method: 'POST',
        data: data || {}
	})
}
// ----------------测评修改用户信息选项
export function updateUserinfoOption(data){
	return request({
		url: '/cms_ceping/updateUserinfoOption',
        method: 'POST',
        data: data || {}
	})
}
// ----------------测评删除用户信息选项
export function deleteUserinfoOption(data){
	return request({
		url: '/cms_ceping/deleteUserinfoOption',
        method: 'POST',
        data: data || {}
	})
}
// ----------------测评获取用户信息
export function getUserinfoOption(data){
	return request({
		url: '/cms_ceping/getUserinfoOption',
        method: 'POST',
        data: data || {}
	})
}
// ----------------测评移动用户信息选项
export function moveUserinfoOption(data){
	return request({
		url: '/cms_ceping/moveUserinfoOption',
        method: 'POST',
        data: data || {}
	})
}

// ----------------测评订单列表
export function orderList(data){
	return request({
		url: '/cms_ceping/orderList',
        method: 'POST',
        data: data || {}
	})
}
// ----------------测评订单导出
export function orderExport(data){
	return request({
		url: '/cms_ceping/orderExport',
        method: 'POST',
        data: data || {}
	})
}

// ----------------测评商品--添加分类
export function addProductCategory(data){
	return request({
		url: '/cms_ceping/addProductCategory',
        method: 'POST',
        data: data || {}
	})
}
// ----------------测评商品--获取分类
export function getProductCategory(data){
	return request({
		url: '/cms_ceping/getProductCategory',
        method: 'POST',
        data: data || {}
	})
}
// ----------------测评商品--编辑分类
export function updateProductCategory(data){
	return request({
		url: '/cms_ceping/updateProductCategory',
        method: 'POST',
        data: data || {}
	})
}
// ----------------测评商品--删除分类
export function removeProductCategory(data){
	return request({
		url: '/cms_ceping/removeProductCategory',
        method: 'POST',
        data: data || {}
	})
}
// ----------------测评商品--分类列表
export function productCategoryList(data){
	return request({
		url: '/cms_ceping/productCategoryList',
        method: 'POST',
        data: data || {}
	})
}
// ----------------测评商品--移动分类排序
export function moveProductCategory(data){
	return request({
		url: '/cms_ceping/moveProductCategory',
        method: 'POST',
        data: data || {}
	})
}
// ----------------测评商品--商品列表
export function productList(data){
	return request({
		url: '/cms_ceping/productList',
        method: 'POST',
        data: data || {}
	})
}
// ----------------测评商品--商品 上架/下架
export function changeProductStatus(data){
	return request({
		url: '/cms_ceping/changeProductStatus',
        method: 'POST',
        data: data || {}
	})
}
// ----------------测评商品--删除商品
export function deleteProduct(data){
	return request({
		url: '/cms_ceping/deleteProduct',
        method: 'POST',
        data: data || {}
	})
}
// ----------------测评商品--全部商品
export function productAll(data){
	return request({
		url: '/cms_ceping/productAll',
        method: 'POST',
        data: data || {}
	})
}
// ----------------测评商品--获取商品
export function getProduct(data){
	return request({
		url: '/cms_ceping/getProduct',
        method: 'POST',
        data: data || {}
	})
}
// ----------------测评商品--添加商品
export function addProduct(data){
	return request({
		url: '/cms_ceping/addProduct',
        method: 'POST',
        data: data || {}
	})
}
// ----------------测评商品--编辑商品
export function updateProduct(data){
	return request({
		url: '/cms_ceping/updateProduct',
        method: 'POST',
        data: data || {}
	})
}

// ----------------测评商品--获取兑换码列表
export function codeList(data){
	return request({
		url: '/cms_ceping/codeList',
        method: 'POST',
        data: data || {}
	})
}

// ----------------测评商品--添加兑换码
export function addCode(data){
	return request({
		url: '/cms_ceping/addCode',
        method: 'POST',
        data: data || {}
	})
}

// ----------------测评商品--兑换码失效
export function disableCode(data){
	return request({
		url: '/cms_ceping/disableCode',
        method: 'POST',
        data: data || {}
	})
}
// ----------------测评商品--兑换码记录导出
export function exportCodeuseList(data){
	return request({
		url: '/cms_ceping/exportCodeuseList',
        method: 'POST',
        data: data || {}
	})
}
// ----------------测评商品--兑换码使用记录
export function codeuseList(data){
	return request({
		url: '/cms_ceping/codeuseList',
        method: 'POST',
        data: data || {}
	})
}

// ----------------测评用户信息--查询可导出的测评
export function cepingInfoAll(data){
	return request({
		url: '/cms_ceping/cepingInfoAll',
        method: 'POST',
        data: data || {}
	})
}


// ----------------测评用户信息--用户信息列表
export function evaluationInfoList(data){
	return request({
		url: '/cms_ceping/evaluationInfoList',
        method: 'POST',
        data: data || {}
	})
}


// ----------------测评用户信息--用户信息导出
export function evaluationInfoAll(data){
	return request({
		url: '/cms_ceping/evaluationInfoAll',
        method: 'POST',
        data: data || {}
	})
}


// ----------------测评广告--测评广告列表
export function adList(data){
	return request({
		url: '/cms_ceping/adList',
        method: 'POST',
        data: data || {}
	})
}


// ----------------测评广告--测评广告新增
export function addAd(data){
	return request({
		url: '/cms_ceping/addAd',
        method: 'POST',
        data: data || {}
	})
}

// ----------------测评广告--测评广告修改
export function updateAd(data){
	return request({
		url: '/cms_ceping/updateAd',
        method: 'POST',
        data: data || {}
	})
}

// ----------------咨询师管理--充值记录
export function chargeLogList(data){
	return request({
		url: '/cms_consultant_admin/chargeLogList',
        method: 'POST',
        data: data || {}
	})
}
// ----------------咨询师管理--充值记录-导出
export function chargeLogAll(data){
	return request({
		url: '/cms_consultant_admin/chargeLogAll',
        method: 'POST',
        data: data || {}
	})
}

// ----------------测评管理--渠道管理-渠道列表
export function sourceList(data){
	return request({
		url: '/cms_ceping/sourceList',
        method: 'POST',
        data: data || {}
	})
}

// ----------------测评管理--渠道管理-添加渠道
export function addSource(data){
	return request({
		url: '/cms_ceping/addSource',
        method: 'POST',
        data: data || {}
	})
}

// ----------------测评管理--渠道管理-获取渠道
export function getSource(data){
	return request({
		url: '/cms_ceping/getSource',
        method: 'POST',
        data: data || {}
	})
}

// ----------------测评管理--渠道管理-更新渠道
export function updateSource(data){
	return request({
		url: '/cms_ceping/updateSource',
        method: 'POST',
        data: data || {}
	})
}


/**
 * 扫码统计---获取选项
 * @param {*} data 
 */
export function scanOptions(data){
	return request({
		url: '/cms_ceping/scanOptions',
        method: 'POST',
        data: data || {}
	})
}

/**
 * 扫码统计---获取统计信息
 * @param {*} data 
 */
export function scanInfo(data){
	return request({
		url: '/cms_ceping/scanInfo',
        method: 'POST',
        data: data || {}
	})
}

/**
 * ---获取统计信息
 * @param {*} data 
 */
export function ceping_event(data){
	return request({
		url: '/cms_ceping/event',
        method: 'POST',
        data: data || {}
	})
}
